module.exports = __webpack_public_path__ + "static/massage-therapist-in-west-loop-final-9fd7f6acbebc0a43f38bb89e578b5054.webp";